import { Component } from '@angular/core';

import { TableAction } from '../../../../../shared/ui/custom-table/model/table-action.model';
import { TableColumn } from '../../../../../shared/ui/custom-table/model/table-column.model';
import { PaymentCardTypes } from '../../../../../modules/finanzas/paymentcard/paymentcard.model';
import { PaymentCardListBase } from '../shared/payment-card-list.base';
import { PaymentCardRow } from '../../payment-card.utils';

@Component({
  standalone: false,
  selector: 'app-debit-card-list-v2',
  templateUrl: './debit-card-list.components.html',
  styleUrls: ['./debit-card-list.components.css']
})
export class DebitCardListV2Component extends PaymentCardListBase {

  readonly cardType = PaymentCardTypes.Tarjeta_Debito;
  readonly icon = 'credit_card';
  readonly title = 'Tarjetas de débito';
  readonly subTitle = 'Consulta, edita o gestiona tus tarjetas de débito';
  protected readonly entityLabel = 'tarjetas de débito';

  protected rowActions(): TableAction[] {
    return [
      { label: 'Editar', icon: 'edit', callback: (row: PaymentCardRow) => this.edit(row) },
      { label: 'Eliminar', icon: 'delete', callback: (row: PaymentCardRow) => this.delete(row) },
    ];
  }

  protected extraColumns(): TableColumn[] {
    return [];
  }

  protected deleteMessage(): string {
    return '¿Seguro que quieres eliminar esta tarjeta de débito? Esta acción no se puede deshacer.';
  }
}
